<template>
  <section class="filters">
    <div>
      <FilterPublisher :nbVoodooGames="nbVoodooGames" />
    </div>
    <div class="spacer"></div>
    <div>
      <Store/>
    </div>
    <div>
      <RefreshButton/>
    </div>
  </section>
</template>

<script>
import FilterPublisher from '@/components/Filters/Publisher';
import RefreshButton from '@/components/Filters/RefreshButton';
import Store from '@/components/Filters/Store';

export default {
  name: 'FiltersComponent',
  props: [
    'nbVoodooGames',
  ],
  components: {
    FilterPublisher,
    RefreshButton,
    Store,
  },
};
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  align-items: center;
  color: #606266;

  &>div {
    &:not(.spacer) {
      margin: 0 10px;
    }

    &.spacer {
      flex: 1;
    }
  }
}
</style>
